module.exports = __webpack_public_path__ + "static/media/trainVideo10.6dcef699.mp4";